<template>
  <div>
    <div class="indexBox waitingSeason" style="margin-top: 80px;">
      <div class="container">
        <img src="@/assets/img/fanzone/coupon_2025.jpg" alt="md_point_info"/>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'CouponHistory',
  data() {
    return {
    };
  },
  created() {
  },
  methods: {
  },
}
</script>
<style lang="scss" scoped>
</style>
